import axios from "axios";
import router from "../../router"; // Lecture 364
import store from "../store";
import {
  PARAM_REDIRECT_ON_USER_EXIST,
  PARAM_LOGIN,
  PARAM_HIDE_ERROR_MODAL
} from "../../constants/url-params";
import { DEFAULT_LOGIN_PAGE_HELPER_TEXT } from "../../constants/default-values";
import tryGet from "../../utils/try-get";

const state = {
  userToken: null,
  userId: null,
  isAgent: null,
  isCandidate: null,
  isEmployer: null,
  userEmail: null,
  // userProfile: null,
  // agencyID: 20,
  // agencyName: 'GoldCoastNannies',
  agencyID: null,
  agencyName: "",
  agency: {},
  userProfile: {},
  loggedinUser: null,
  listJobIdFillers: [], // List of job ID the current login user (candidate only) is assigned to (in case of multi-filler = true)
  stripeAccountID: "" //
};

const mutations = {
  authUser(state, userData) {
    console.log("Storing Authentication Data");
    state.userToken = userData.token;
    state.userId = userData.user_id;
    state.isAgent = userData.is_agent;
    state.isCandidate = userData.is_candidate;
    state.isEmployer = userData.is_employer;
    state.agencyID = userData.agency_id;
    state.agencyName = userData.agency_owner;
    state.userEmail = userData.email;
    if (userData.agency) {
      state.agency = userData.agency;
    }
  },
  storeUser(state, userData) {
    state.userProfile = userData;
  },
  clearAuthData(state) {
    state.userToken = null;
    // state.userProfile = null
    state.userId = null;
    state.isAgent = null;
    state.isCandidate = null;
    state.isEmployer = null;
    state.loggedinUser = null;
  },
  setAgency(state, agency) {
    state.agency = agency;
  },
  setAgencyID(state, payload) {
    state.agencyID = payload;
  },
  setLoggedinUser(state, payload) {
    state.loggedinUser = payload;
  },
  setListJobIdFillers(state, payload) {
    state.listJobIdFillers = payload;
  }
};

const actions = {
  setAgencyID({ commit }, payload) {
    commit("setAgencyID", payload);
  },
  setAgency({ commit }, payload) {
    commit("setAgency", payload);
  },
  setListJobIdFillers({ commit }, payload) {
    commit("setListJobIdFillers", payload);
  },
  setLoggedinUser({ commit, dispatch }, payload) {
    commit("setLoggedinUser", payload);
    dispatch("loadMessagesSummary", null, { root: true });
  },
  tryAutoLogin({ commit, dispatch }) {
    // Lecture 366
    const stored_token = localStorage.getItem("token");
    if (!stored_token) {
      return;
    }
    // const expirationDate = localStorage.getItem('expirationDate')
    // const now = new Date()
    // if (now >= expirationDate) {
    //   return
    // }
    let is_agent = false;
    let is_candidate = false;
    let is_employer = false;
    const stored_user_id = Number(localStorage.getItem("user_id"));
    const stored_is_agent = localStorage.getItem("is_agent");
    if (stored_is_agent === "true") {
      is_agent = true;
    }
    const stored_is_candidate = localStorage.getItem("is_candidate");
    if (stored_is_candidate === "true") {
      is_candidate = true;
    }
    const stored_is_employer = localStorage.getItem("is_employer");
    if (stored_is_employer === "true") {
      is_employer = true;
    }
    const stored_agency_id = localStorage.getItem("agency_id");
    const stored_agency_owner = localStorage.getItem("agency_owner");
    const stored_agency = localStorage.getItem("agency");
    const user_email = localStorage.getItem("user_email");

    commit("authUser", {
      token: stored_token,
      user_id: stored_user_id,
      is_agent: is_agent,
      is_candidate: is_candidate,
      is_employer: is_employer,
      agency_id: stored_agency_id,
      agency_owner: stored_agency_owner,
      agency: stored_agency,
      email: user_email
    });

    dispatch("increaseReloadAgencyReqNumber", 1); // Load agency data
    dispatch("loadRecentAccessLog");
  },
  saveAuthUser({commit}, payload) {
    const agencyID = payload.agency_id;
    const agencyName = payload.agency_name;
    commit("authUser", {
      token: payload.token,
      user_id: payload.user_id,
      is_agent: payload.is_agent,
      is_candidate: payload.is_candidate,
      is_employer: payload.is_employer,
      agency_id: agencyID,
      agency_owner: agencyName,
      email: payload.email,
      category: payload.category
    });
    // Need to save both of these for the authUser mutation
    try {
      localStorage.setItem("token", payload.token); // Lecture 366
      localStorage.setItem("user_id", payload.user_id);
      localStorage.setItem("is_agent", payload.is_agent);
      localStorage.setItem("is_candidate", payload.is_candidate);
      localStorage.setItem("is_employer", payload.is_employer);
      localStorage.setItem("agency_id", agencyID);
      localStorage.setItem("agency_owner", agencyName);
      localStorage.setItem("user_email", payload.email);
      localStorage.setItem("admin_category", payload.category);
    } catch (error) {
      console.log(error);
    }
  },
  login({ commit, dispatch }, authData) {
    // Reset some lists (in case user login for user of another agency)
    dispatch("setPriceList", null, { root: true });
    dispatch("setAvailabilities", null, { root: true });
    dispatch("setWeekAvailabilities", null, { root: true });
    dispatch("setCandidateListMainInfo", null, { root: true });
    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    console.log(authData);
    let hide_error = authData.hide_error ? true : false;
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/api-token-auth/?${PARAM_LOGIN}&${PARAM_HIDE_ERROR_MODAL}=${hide_error}`,
          {
            username: authData.email,
            password: authData.password,
            // agency: state.agencyID,
            agency: authData.agency,
            force: authData.force
          }
        )
        .then(async res => {
          console.log("Successful Login");

          if (!res) {
            resolve("failed");
            return;
          }

          if (res.response && res.response.status == 409) {
            resolve("multi-login");
            return;
          }

          // In case user just created, it response default agencyID, we need to load old agency
          let agencyID = res.data.agency_id;
          if (agencyID === 1 && state.agencyID) {
            agencyID = state.agencyID;
          }
          commit("authUser", {
            token: res.data.token,
            user_id: res.data.user_id,
            is_agent: res.data.is_agent,
            is_candidate: res.data.is_candidate,
            is_employer: res.data.is_employer,
            agency_id: agencyID,
            agency_owner: res.data.agency_owner,
            email: res.data.email
          });
          dispatch("loadRecentAccessLog");
          // Need to save both of these for the authUser mutation
          try {
            localStorage.setItem("token", res.data.token); // Lecture 366
            localStorage.setItem("user_id", res.data.user_id);
            localStorage.setItem("is_agent", res.data.is_agent);
            localStorage.setItem("is_candidate", res.data.is_candidate);
            localStorage.setItem("is_employer", res.data.is_employer);
            localStorage.setItem("agency_id", agencyID);
            localStorage.setItem("agency_owner", res.data.agency_owner);
            localStorage.setItem("user_email", res.data.email);
          } catch (error) {
            console.log(error);
          }

          if (res.data.agency_id != 1) {
            // The agency ID is 1 when doing the login on registration, because the agency ID hasn't been set yet
            dispatch("increaseReloadAgencyReqNumber", 1); // Load agency data
          }

          // const now = new Date()
          // const expirationDate = new Date(now.getTime() + 3600000) // Covert the date to milliseconds, add an hour, then convert back to a date
          // localStorage.setItem('expirationDate', expirationDate)
          resolve("sucess");
        })
        // Problem logging in, likely incorrect email or password, or account doesn't exist
        .catch(error => {
          console.log(error);
          resolve("failed");
        });
    });
  },
  async updateUser({ commit }, payload) {
    const res = await axios.patch(`/api/people/${payload.userId}`, payload.body);
    if (res && res.data) {
      commit("setLoggedinUser", res.data);
    }
  },
  logout({ commit }, redirect) {
    commit("clearAuthData");
    // router.replace('/login') // After someone logs out send them to the login page - Lecture 364
    // router.push({name: 'Login'}) // https://router.vuejs.org/guide/essentials/navigation.html
    if (redirect != "no-redirect") {
      router
        .push({ name: "Login", params: { agencyID: state.agencyID } })
        .catch(() => { }); // https://router.vuejs.org/guide/essentials/navigation.html
    }

    // When someone logs out we want to clear their auth details from the browser, so they have to log back in - Lecture 366
    // localStorage.removeItem('expirationDate')
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("is_agent");
      localStorage.removeItem("agency_id");
      localStorage.removeItem("agency_owner");
      localStorage.removeItem("agency");
      localStorage.removeItem("user_email");
      localStorage.removeItem("show_app_popup");
    } catch (error) {
      console.log(error);
    }
  },
  loadLoggedinUser({ commit, state }) {
    return new Promise(async resolve => {
      if (!state.userId) {
        resolve();
        return;
      }
      // Already loaded
      if (state.loggedinUser) {
        resolve();
        return;
      }
      const res = await axios.get(`/api/people/${state.userId}`);
      if (res && res.data) {
        commit("setLoggedinUser", res.data);
      }
      resolve();
    });
  },
  test({ commit }) {
    console.log("Test successful.");
  },
  getAgency({ commit }, agencyID) {
    //
    // This updates the global agency object for use throughout
    // Initially set up for getting the agency on registration for a direct redirect to the user dashboard (for some reason the agency object was not being set on login)
    //
    console.log(agencyID);
    axios
      .get(`/api/agencies/?id=${agencyID}`)
      .then(res => {
        state.agency = res.data[0];
        try {
          localStorage.setItem("agency", res.data[0]);
          console.log(res.data[0]);
        } catch (error) {
          console.log(error);
        }
      })
      .catch(error => console.log(error));
  },
};

const getters = {
  clientSelfSelectsCandidateForShiftJobEmails: state =>
    tryGet(
      () =>
        state.agency.advance_setting
          .client_self_selects_candidate_for_shift_job_emails
    ) || [],
  hideMileageQuestion: state =>
    tryGet(() => state.agency.advance_setting.hide_mileage_question) || false,
  hideReimbursementQuestion: state =>
    tryGet(() => state.agency.advance_setting.hide_reimbursement_question) ||
    false,
  disableCandidateAssignManagerEmail: state =>
    tryGet(
      () => state.agency.advance_setting.disable_candidate_assign_manager_email
    ) || false,
  selectedTimeSheetTableColumns: state =>
    tryGet(() => state.agency.advance_setting.time_sheet_table_columns) || [],
  showSquareProfilePic: state =>
    tryGet(() => state.agency.public_advance_setting.show_square_profile_pic) ||
    false,
  showIdClientSideShiftJobCalendar: state =>
    tryGet(
      () => state.agency.advance_setting.show_id_client_side_shift_job_calendar
    ) || false,
  clientTableTypesColorList: state =>
    tryGet(() => state.agency.advance_setting.client_table_types_color) || [],
  clientTableTagsColorList: state =>
    tryGet(() => state.agency.advance_setting.client_table_tags_color) || [],
  candidateTableTypesColorList: state =>
    tryGet(() => state.agency.advance_setting.candidate_table_types_color) ||
    [],
  candidateTableTagsColorList: state =>
    tryGet(() => state.agency.advance_setting.candidate_table_tags_color) || [],
  candidateMarkedAsFavoriteDoNotWantAgain: state =>
    tryGet(
      () =>
        state.agency.advance_setting
          .candidate_marked_as_favorite_do_not_want_again
    ) || [],
  useHomeScreen: state =>
    tryGet(() => state.agency.public_advance_setting.use_new_home_screen) ||
    false,
  usingExperiencesAsReference: state =>
    tryGet(
      () => state.agency.public_advance_setting.using_experience_as_reference
    ) || false,
  useCandidateCommunity: state =>
    tryGet(() => state.agency.public_advance_setting.use_candidate_community) ||
    false,
  getAgentClassification: state => tryGet(() => state.agentClassification),
  showPriceManagerOnAdministratorsTable: state =>
    tryGet(
      () =>
        state.agency.advance_setting.show_price_manager_on_administrators_table
    ) || false,
  userID(state) {
    return state.userId;
  },
  userToken(state) {
    return state.userToken;
  },
  isAuthenticated(state) {
    return state.userToken !== null;
  },
  isAgent(state) {
    return state.isAgent;
  },
  isCandidate(state) {
    return state.isCandidate;
  },
  isEmployer(state) {
    return state.isEmployer;
  },
  userAPIURL(state) {
    return "/api/people/".concat(state.userId.toString()).concat("/");
  },
  agencyID(state) {
    return state.agencyID;
  },
  agencyName(state) {
    return state.agencyName;
  },
  agency(state) {
    return state.agency;
  },
  stripeAccountID(state) {
    return state.stripeAccountID;
  },
  userEmail(state) {
    return state.userEmail;
  },
  loggedinUser(state) {
    return state.loggedinUser;
  },
  listJobIdFillers(state) {
    return state.listJobIdFillers;
  },
  userSettings(state) {
    return state.userSettings;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js